import { createFileRoute } from "@tanstack/react-router";
import AuthGuard from "../components/AuthGuard";
import BookingDetailPage from "../components/booking/BookingDetailPage";

export const Route = createFileRoute("/bookings/$bookingGuid/")({
  component: () => (
    <AuthGuard>
      <BookingDetailPage />
    </AuthGuard>
  ),
});
